export const formatPrice = (price: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    price
  );

export const parseTargetPrice = (value: string) => {
  const price = parseFloat(value);
  if (Number.isNaN(price) || price <= 0) return null;
  return price;
};
